import {getCustomerOptions} from '@/services/DocService';
export async function  getCustomerOpts(params){
  try {
   const res= await getCustomerOptions(params)
   return res
  } catch (error) {
    console.log(error);
  }
}